import { useForm } from '@mantine/form';

import { serviceTypes } from '../types';

export type Fields = Pick<serviceTypes.Service, 'name' | 'department' | 'key'>;
type ServiceFormProps = {
  initialValues: Fields;
};

export const useServiceForm = ({ initialValues }: ServiceFormProps) => {
  return useForm({
    initialValues: {
      name: initialValues.name,
      key: initialValues.key,
      department: initialValues.department,
    },

    validate: {
      name: (value) => (!value ? 'Name is required' : null),
      key: (value) => (!value ? 'Key is required' : null),
      department: (value) => (!value ? 'Department is required' : null),
    },
  });
};
